import React from 'react';

import EditListModal from '../EditListModal';

const PersonsSummary = ({ title, persons, setPersons }) => {
    if (persons === null || persons === undefined || persons.length === 0) {
        return null;
    }

    return (
        <div className='d-flex flex-column card w-100 detail-card-info-form'>
            <h3 className='crm-header px-3 pt-3 pb-2'>
                {title} ({persons.length})
            </h3>
            <PersonsSummaryHeader />
            <div className='crm-detail-hline' />
            <div className='d-flex flex-column'>
                {persons.map((person, index) => {
                    return index < 10 ? <PersonsSummaryRow key={`persons-summary-${person.id}`} person={person} /> : null;
                })}
            </div>
            <EditListModal persons={persons} setPersons={setPersons} />
        </div>
    );
};

export default PersonsSummary;

const PersonsSummaryHeader = () => {
    return (
        <div className='d-flex flex-row px-3 py-1 w-100'>
            <div className='pl-2 w-25'>Namn</div>
            <div className='pl-2 w-25'>Roll</div>
            <div className='pl-2 w-25'>Email</div>
            <div className='pl-2 w-25'>Telefon</div>
        </div>
    );
};

const PersonsSummaryRow = ({ person }) => {
    return (
        <div className='d-flex flex-row border-bottom px-3 py-2 w-100'>
            <div className='pl-2 w-25'>{person.name}</div>
            <div className='pl-2 w-25'>{person.role !== null ? person.role.name : null}</div>
            <div className='pl-2 w-25'>{person.email}</div>
            <div className='pl-2 w-25'>{person.phone}</div>
        </div>
    );
};
